const es = {
  common: { languageEs: "ES", languageEn: "EN", brand: "Equestrian Partners" },
  nav: { book: "Comenzar" },
  blog: {
    metaTitle: "Blog · Equestrian Partners", metaDesc: "Ideas, estrategia y conocimiento del sector ecuestre por Equestrian Partners.",
    eyebrow: "Journal", title: "Blog", subtitle: "Ideas, estrategia y conocimiento para transformar el sector ecuestre en negocios reales.",
    backHome: "Inicio", read: "Leer artículo", empty: "Aún no hay artículos publicados.",
    notFound: "Artículo no encontrado", allArticles: "Todos los artículos", faqTitle: "Preguntas frecuentes",
  },
  hero: {
    title: "¿Tienes una idea para el sector ecuestre?",
    subtitle: "Nosotros la convertimos en una empresa.",
    tagline: "Equestrian Events · Ventures · Tecnología · IA",
    ctaPrimary: "Reservar sesión estratégica",
    ctaSecondary: "Descubrir cómo trabajamos",
  },
  statement: {
    title: "El sector ecuestre sigue resolviendo muchos problemas como hace veinte años.",
    subtitle: "Nosotros transformamos esos problemas en oportunidades.",
    button: "Explorar posibilidades",
  },
  expertise: {
    overline: "Nuestra ventaja",
    title1: "No aprendimos el sector desde fuera.",
    title2: "Lo hemos vivido desde dentro.",
    intro: "Durante más de dos décadas hemos trabajado en prácticamente todos los niveles de la industria ecuestre.",
    roles: [
      "Como deportistas.",
      "Como organizadores.",
      "Como empresarios.",
      "Como desarrolladores de proyectos.",
      "Como asesores.",
      "Como constructores de negocio.",
    ],
    outro: "Por eso vemos oportunidades que una agencia tecnológica convencional nunca detectaría.",
  },
  opportunities: {
    overline: "Posibilidades",
    title: "Una visión de lo que podríamos construir juntos.",
    items: [
      { title: "Performance Intelligence", desc: "IA para analizar rendimiento deportivo." },
      { title: "Broadcast Intelligence", desc: "IA para transformar competiciones en experiencias audiovisuales premium." },
      { title: "Stable Operations", desc: "Automatización de operaciones para centros ecuestres." },
      { title: "Equestrian Commerce", desc: "Nuevos modelos digitales para monetizar conocimiento, servicios y comunidad." },
    ],
  },
  method: {
    overline: "Método Equestrian Partners™",
    title1: "No construimos más.",
    title2: "Construimos mejor.",
    chapter: "CAPÍTULO",
    steps: [
      { title: "Eliminar", body: "Cuestionamos todos los supuestos. Eliminamos lo innecesario." },
      { title: "Simplificar", body: "Reducimos el problema a su esencia." },
      { title: "Diseñar", body: "Creamos la solución correcta." },
      { title: "Construir", body: "Desarrollamos únicamente lo que aporta valor." },
      { title: "Escalar", body: "Convertimos el proyecto en un negocio." },
    ],
  },
  product: {
    overline: "Producto principal",
    title: "Reserva una sesión estratégica.",
    price: "60 minutos. 299 €.",
    subtitle: "Saldrás con claridad total sobre tu proyecto.",
    duringTitle: "Durante la sesión",
    during: [
      "Analizamos la idea",
      "Detectamos oportunidades",
      "Validamos el mercado",
      "Diseñamos el producto",
      "Definimos el MVP",
      "Identificamos riesgos",
      "Diseñamos monetización",
      "Estimamos inversión",
      "Diseñamos hoja de ruta",
    ],
    resultTitle: "El resultado",
    resultDesc: "Documento premium entregado tras la reunión.",
    chips: [
      "Visión del producto", "Propuesta de valor", "Funcionalidades", "Arquitectura",
      "Roadmap", "Monetización", "Presupuesto estimado", "Riesgos", "Oportunidades",
    ],
    book: "Reservar sesión estratégica · 299 €",
  },
  faq: {
    overline: "Preguntas frecuentes",
    title: "Todo lo que necesitas saber.",
    items: [
      { q: "¿Qué hacéis exactamente?", a: "Desarrollamos aplicaciones, software, inteligencia artificial, automatizaciones y nuevos modelos digitales para empresas y profesionales del sector ecuestre." },
      { q: "¿Tengo que saber de tecnología?", a: "No. Nosotros traducimos tu experiencia del sector en una solución tecnológica viable." },
      { q: "¿Qué ocurre durante la sesión estratégica?", a: "Realizamos una sesión privada de diagnóstico donde analizamos la idea, el modelo de negocio, el mercado, la viabilidad y la tecnología necesaria. Posteriormente entregamos un blueprint estratégico." },
      { q: "¿Qué incluye el blueprint?", a: "Visión del proyecto, funcionalidades, arquitectura recomendada, roadmap, estimación económica y recomendaciones estratégicas." },
      { q: "¿Cuánto cuesta la sesión?", a: "299 €. El importe se autoriza al reservar y solo se captura tras la celebración de la reunión." },
      { q: "¿Desarrolláis vosotros el proyecto?", a: "Sí. Podemos encargarnos desde la estrategia hasta el desarrollo completo." },
      { q: "¿Trabajáis con clubes, federaciones y organizadores?", a: "Sí. Trabajamos con emprendedores, empresas, clubes, organizadores, federaciones e inversores del sector ecuestre." },
      { q: "¿La sesión es online o presencial?", a: "La sesión se realiza online, en un formato privado de 60 minutos." },
      { q: "¿Qué ocurre después de la sesión?", a: "Recibes tu Equestrian Blueprint™ y, si decides avanzar, te acompañamos en el desarrollo y la puesta en marcha del proyecto." },
    ],
  },
  finalCta: {
    title: "Las mejores empresas del sector comenzaron siendo una idea.",
    subtitle: "La diferencia es que alguien decidió construirlas.",
    button: "Reservar sesión estratégica · 299 €",
  },
  footer: {
    book: "Reservar sesión estratégica",
    tagline: "Technology & Venture Builders for the Equestrian Industry.",
    navTitle: "Navegación",
    nav: { home: "Inicio", how: "Cómo trabajamos", session: "Sesión estratégica", faq: "Preguntas frecuentes", blog: "Blog", contact: "Contacto" },
    contactTitle: "Contacto",
    legalTitle: "Legal",
    legal: { privacy: "Política de privacidad", cookies: "Política de cookies", terms: "Términos y condiciones" },
    rights: "Todos los derechos reservados.",
    cookiePrefs: "Preferencias de cookies",
  },
  booking: {
    back: "Volver",
    overline: "Sesión estratégica",
    title: "Reserva tu sesión.",
    subtitle: "60 minutos · 299 €. Saldrás con claridad total sobre tu proyecto.",
    name: "Nombre", namePh: "Tu nombre",
    email: "Email", emailPh: "tu@email.com",
    phone: "Teléfono", phonePh: "+34 ...",
    company: "Empresa (opcional)", companyPh: "Nombre de tu empresa",
    idea: "Describe brevemente tu idea", ideaPh: "¿Qué quieres construir para el sector ecuestre?",
    chooseDate: "Elige una fecha",
    chooseTime: "Elige una hora",
    submit: "Continuar al pago · 299 €",
    submitting: "Redirigiendo al pago…",
    secure: "Pago seguro procesado por Stripe.",
    errorRequired: "Completa todos los campos obligatorios.",
  },
  payment: {
    checking: "Confirmando tu pago…",
    successTitle: "Sesión reservada.",
    successBody: "Tu sesión estratégica está confirmada. Hemos autorizado 299 € en tu tarjeta, pero el importe no se cobra ahora: solo lo capturaremos tras celebrar la reunión. Te contactaremos por email para coordinar los detalles y recibirás tu Equestrian Blueprint™.",
    home: "Volver al inicio",
    pendingTitle: "Procesando el pago",
    pendingBody: "Tu pago se está procesando. Recibirás una confirmación por email en breve.",
    errorTitle: "No se pudo confirmar el pago",
    errorBody: "Inténtalo de nuevo o escríbenos si el problema persiste.",
    retry: "Reintentar reserva",
  },
  cookie: {
    title: "Usamos cookies",
    body: "Utilizamos cookies para el funcionamiento del sitio, analítica y personalización. Puedes aceptarlas todas, rechazarlas o configurarlas. Consulta nuestra",
    policyLink: "Política de cookies",
    customize: "Personalizar",
    reject: "Rechazar todas",
    accept: "Aceptar todas",
    prefsOverline: "Preferencias",
    modalTitle: "Configuración de cookies",
    save: "Guardar selección",
    categories: [
      { title: "Necesarias", desc: "Esenciales para el funcionamiento del sitio. No pueden desactivarse." },
      { title: "Funcionales", desc: "Permiten recordar tus preferencias y mejorar la experiencia." },
      { title: "Preferencias", desc: "Guardan ajustes personalizados como idioma o región." },
      { title: "Analítica", desc: "Nos ayudan a entender cómo se usa el sitio para mejorarlo." },
      { title: "Marketing", desc: "Se utilizan para mostrar contenido y campañas relevantes." },
    ],
  },
  legal: {
    back: "Volver",
    updated: "Última actualización: 2026",
    privacidad: {
      title: "Política de privacidad",
      blocks: [
        ["Responsable del tratamiento", "Equestrian Partners es responsable del tratamiento de los datos personales que nos facilitas a través de este sitio web. Para cualquier consulta sobre privacidad puedes escribirnos a contact@equestrianpartners.net."],
        ["Datos que recopilamos", "Recopilamos los datos que nos proporcionas al reservar una sesión estratégica (nombre, email, teléfono, empresa opcional y una descripción de tu idea), así como datos técnicos de navegación cuando das tu consentimiento (cookies analíticas y de marketing)."],
        ["Finalidad", "Utilizamos tus datos para gestionar la reserva y el pago de la sesión, prestarte el servicio contratado, elaborar tu Equestrian Blueprint™ y comunicarnos contigo. Los datos técnicos se usan para mejorar el sitio y, si lo consientes, para acciones de marketing."],
        ["Base legal", "El tratamiento se basa en la ejecución del contrato (reserva y sesión), tu consentimiento (cookies y comunicaciones comerciales) y nuestro interés legítimo en mejorar nuestros servicios."],
        ["Conservación", "Conservamos tus datos durante el tiempo necesario para prestar el servicio y cumplir con nuestras obligaciones legales. Después se suprimen o anonimizan."],
        ["Tus derechos", "Puedes ejercer tus derechos de acceso, rectificación, supresión, oposición, limitación y portabilidad escribiéndonos a contact@equestrianpartners.net. También puedes reclamar ante la autoridad de control competente."],
        ["Encargados y pagos", "El pago se procesa de forma segura a través de Stripe, que actúa como encargado del tratamiento conforme al RGPD. No almacenamos los datos de tu tarjeta."],
      ],
    },
    cookies: {
      title: "Política de cookies",
      blocks: [
        ["¿Qué son las cookies?", "Las cookies son pequeños archivos que se almacenan en tu dispositivo al navegar. Nos permiten que el sitio funcione, recordar tus preferencias y, si lo consientes, medir y personalizar la experiencia."],
        ["Categorías que utilizamos", "Necesarias (esenciales, siempre activas), Funcionales (funcionalidades y preferencias), Preferencias (ajustes personalizados), Analítica (medición de uso) y Marketing (contenido y campañas relevantes)."],
        ["Gestión del consentimiento", "Al acceder por primera vez puedes Aceptar todas, Rechazar todas o Personalizar por categoría. Puedes cambiar tu decisión en cualquier momento desde 'Preferencias de cookies' en el pie de página."],
        ["Cumplimiento", "Este sitio cumple con el RGPD y la normativa europea de cookies. No se activan cookies no esenciales sin tu consentimiento previo."],
      ],
    },
    terminos: {
      title: "Términos y condiciones",
      blocks: [
        ["Objeto", "Estas condiciones regulan el uso del sitio y la contratación de la sesión estratégica de Equestrian Partners."],
        ["La sesión estratégica", "La sesión tiene una duración de 60 minutos y un precio de 299 €. Tras su celebración entregamos el documento Equestrian Blueprint™ con el análisis del proyecto."],
        ["Pago y autorización", "Al reservar, Stripe autoriza el importe de 299 € en tu tarjeta de forma segura, pero no se cobra en ese momento. Capturamos el pago manualmente únicamente tras la celebración de la sesión. Si no se captura, la autorización se libera automáticamente según las reglas de Stripe."],
        ["Cancelaciones", "Si necesitas reprogramar o cancelar, escríbenos a contact@equestrianpartners.net con la mayor antelación posible y buscaremos la mejor solución."],
        ["Propiedad intelectual", "Los contenidos del sitio y la metodología Equestrian Partners™ son propiedad de Equestrian Partners. El Equestrian Blueprint™ entregado es para tu uso conforme a lo acordado."],
        ["Responsabilidad", "El Equestrian Blueprint™ es un documento estratégico de asesoramiento; no constituye una garantía de resultados de negocio."],
        ["Legislación aplicable", "Estas condiciones se rigen por la legislación española y europea aplicable."],
      ],
    },
  },
  admin: {
    os: "BLUEPRINT MEETING OS",
    restricted: "Acceso restringido",
    emailPh: "Email", passwordPh: "Contraseña",
    signIn: "Entrar",
    cases: "expedientes",
    selectCase: "Selecciona un expediente",
    paid: "Pagado", authorized: "Autorizado (299 €)", released: "Liberado", unpaid: "No pagado",
    statusPending: "Pago pendiente", statusAuthorized: "Autorizada", statusConfirmed: "Confirmada", statusReleased: "Liberada",
    capture: "Capturar 299 €", release: "Liberar",
    idea: "La idea",
    aiQuestions: "Preguntas asistidas por IA",
    generate: "Generar",
    notes: "Notas de la sesión", notesPh: "Respuestas y observaciones durante la llamada…",
    save: "Guardar",
    blueprint: "Equestrian Blueprint™",
    regenerate: "Regenerar",
    fieldEmail: "Email", fieldPhone: "Teléfono", fieldCompany: "Empresa", fieldDateTime: "Fecha / Hora",
    logout: "Cerrar sesión",
    toastCaptured: "Pago capturado · 299 € cobrados",
    toastReleased: "Autorización liberada",
    toastNotesSaved: "Notas guardadas",
    toastBlueprint: "Equestrian Blueprint™ generado",
    toastBlueprintErr: "No se pudo generar el blueprint",
    toastLoadErr: "No se pudieron cargar las reservas",
    record: "Grabar reunión", recording: "Grabando… detener", transcribing: "Transcribiendo…",
    structureTitle: "Organización en tiempo real", structure: "Estructurar",
    sVision: "Visión", sProblem: "Problema", sSolution: "Solución", sMarket: "Mercado",
    sMonetization: "Monetización", sFeatures: "Funcionalidades", sRoadmap: "Roadmap",
    sRisks: "Riesgos", sOpportunities: "Oportunidades", sBudget: "Presupuesto preliminar",
    sNextSteps: "Próximos pasos", sMissing: "Información que falta",
    toastTranscribed: "Audio transcrito y añadido a las notas",
    toastStructured: "Información estructurada",
    toastRecordErr: "No se pudo acceder al micrófono",
    sendBlueprint: "Enviar al cliente", sendingBlueprint: "Enviando…",
    toastBlueprintSent: "Blueprint enviado al cliente por email",
    toastBlueprintSentErr: "No se pudo enviar el Blueprint",
    reschedule: "Reprogramar", rescheduling: "Reprogramando…",
    toastRescheduled: "Sesión reprogramada · email enviado al cliente",
    toastRescheduleErr: "No se pudo reprogramar",
    searchPh: "Buscar cliente o empresa…",
    tabUpcoming: "Próximas", tabPast: "Pasadas", tabAll: "Todas",
    noBookings: "Sin reservas",
    overview: "Resumen", interview: "Entrevista", intelligence: "Inteligencia", budgetTab: "Presupuesto",
    secClient: "Ficha del cliente", secInterview: "Entrevista", secAI: "Estructuración con IA",
    secBudget: "Propuesta económica",
    pipelineTitle: "Pipeline del proyecto",
    stages: {
      lead: "Lead",
      meeting_booked: "Reunión reservada",
      interview_done: "Entrevista completada",
      blueprint_generated: "Blueprint generado",
      blueprint_delivered: "Blueprint entregado",
      budget_generated: "Presupuesto generado",
      proposal_sent: "Propuesta enviada",
      project_approved: "Proyecto aprobado",
      in_development: "En desarrollo",
    },
    audioSection: "Audio de la sesión", audioPlay: "Reproducir grabación", audioNone: "Sin grabación en esta sesión",
    budgetPh: "Alcance del proyecto, estimación económica, fases y condiciones…",
    budgetSave: "Guardar presupuesto", toastBudgetSaved: "Presupuesto guardado",
    blueprintEdit: "Editar", blueprintEditPh: "El Blueprint aparecerá aquí. Puedes editarlo antes de enviarlo…",
    toastBlueprintSaved: "Blueprint guardado",
    exportMd: "Descargar", exportPdf: "PDF", printBtn: "Imprimir",
    stageSaved: "Etapa actualizada",
    contactBtn: "Escribir email",
    navNewClient: "Nuevo cliente", navMeetings: "Reuniones", navGrowth: "Growth OS",
    navKnowledge: "Knowledge OS", navSearch: "Búsqueda",
    growth: "Crecimiento", secGrowth: "Plan de crecimiento (Growth OS)",
    growthIntro: "Genera un plan de crecimiento accionable, fundamentado en el Business Reasoning Engine, sin planificación temporal.",
    growthPh: "El plan de crecimiento aparecerá aquí. Puedes editarlo antes de compartirlo…",
    toastBudgetGen: "Propuesta económica generada",
    toastGrowthGen: "Plan de crecimiento generado", toastGrowthSaved: "Plan de crecimiento guardado",
    toastClientCreated: "Cliente creado",
    ncTitle: "Nuevo cliente", ncName: "Nombre", ncEmail: "Email", ncPhone: "Teléfono",
    ncCompany: "Empresa", ncIdea: "Idea / Negocio", ncOrigin: "Origen del cliente",
    ncDate: "Fecha", ncTime: "Hora", ncCreate: "Crear cliente", ncCancel: "Cancelar",
    ncSector: "Sector / Industria", ncSectorPh: "Selecciona un sector…",
    ncBriefing: "Briefing del cliente",
    ncBriefingHint: "Contexto permanente del cliente. La IA lo estudiará antes de generar preguntas, análisis, blueprint y presupuesto.",
    ncBriefingPh: "Pega aquí investigación, web, modelo de negocio, historia, información financiera, noticias, riesgos, problemas detectados, notas, PDFs resumidos…",
    secBriefing: "Briefing del cliente",
    briefingHint: "Contexto permanente. Toda la IA (preguntas, inteligencia, blueprint, presupuesto) lo usa automáticamente.",
    toastBriefingSaved: "Briefing guardado",
    origins: {
      website: "Web", manual: "Manual", referral: "Recomendación", event: "Evento",
      personal_contact: "Contacto personal", network: "Red de contactos", linkedin: "LinkedIn", other: "Otro",
    },
    koTitle: "Knowledge OS", koSubtitle: "Núcleo de conocimiento del Business Reasoning Engine",
    koCore: "Núcleo del sistema", koIndustries: "Industry Knowledge Packs", koKb: "Base de conocimiento",
    koEvidence: "Evidencia y trazabilidad", koIndexed: "Indexado", koChunks: "fragmentos",
    koNotIndexed: "Sin indexar", koVersion: "Versión", koEdit: "Editar", koSave: "Guardar cambios",
    koReindex: "Reindexar todo", koReindexed: "Reindexación completada",
    koMaster: "Master Blueprint Framework", koManual: "Business Reasoning Manual",
    koFramework: "Constitución del razonamiento", koMethod: "Método de razonamiento",
    koSaved: "Documento guardado e indexándose", koChangeSummary: "Resumen del cambio (opcional)",
    koNewPack: "Nuevo pack", koPackName: "Nombre del pack", koActive: "Activo", koInactive: "Inactivo",
    koContent: "Contenido", koNoIndustries: "Aún no hay Industry Knowledge Packs.",
    koNoKb: "Aún no hay entradas en la base de conocimiento.", koTitleField: "Título",
    koNoEvidence: "Sin registros de evidencia todavía.",
    ksTitle: "Búsqueda de conocimiento", ksSubtitle: "Recuperación híbrida (BM25 + embeddings) con reranking",
    ksPlaceholder: "Pregunta al conocimiento del motor de razonamiento…", ksSearch: "Buscar",
    ksNoResults: "Sin resultados. Prueba otra consulta.", ksScore: "score", ksVec: "vector", ksBm: "léxico",
    originAll: "Todos los orígenes", context: "Contexto", secContext: "Contexto del proyecto",
    contextIntro: "Contexto de razonamiento recuperado automáticamente para este cliente (Business Reasoning Engine).",
    contextEmpty: "Aún no hay contexto. Se genera al estructurar la inteligencia de la sesión.",
    refresh: "Actualizar", delete: "Eliminar", deleteConfirm: "¿Eliminar este cliente de forma permanente?",
    confirmTitle: "Confirmar acción", confirmCancel: "Cancelar", confirmDelete: "Eliminar",
    mlDeleteConfirm: "¿Eliminar esta imagen de forma permanente?",
    intSectorDelConfirm: "¿Eliminar este sector?", intSignalDelConfirm: "¿Eliminar esta señal?",
    koDeleteConfirm: "¿Eliminar este paquete de conocimiento?",
    blogPublishedNoHero: "Artículo publicado, pero la imagen de portada no pudo generarse. Puedes añadirla desde el editor.",
    toastDeleted: "Cliente eliminado",
    goTitle: "Growth OS", goSubtitle: "Estrategia de crecimiento de Equestrian Partners (módulo interno)",
    goIntro: "Módulo interno para desarrollar la estrategia de crecimiento, adquisición y promoción de Equestrian Partners como empresa. No está asociado a ningún cliente.",
    goPh: "La estrategia de crecimiento de la empresa aparecerá aquí. Puedes editarla libremente…",
    goEmpty: "Aún no hay estrategia. Genera un primer borrador con IA o escríbela manualmente.",
    goBack: "Volver",
    navMedia: "Media Library", mlSubtitle: "Biblioteca de imágenes y motor de identidad visual",
    mlLibrary: "Biblioteca", mlIdentity: "Identidad visual",
    mlPrompt: "Descripción de la imagen", mlPromptPh: "Ej.: caballo PRE en un picadero al atardecer…",
    mlNoSector: "Sin sector (preset por defecto)", mlGenerate: "Generar", mlUpload: "Subir",
    mlEmpty: "Aún no hay imágenes. Genera o sube la primera.",
    mlGenerated: "Imagen generada", mlUploaded: "Imagen subida", mlGenError: "No se pudo generar la imagen",
    mlPresetFor: "Preset para", mlDefaultPreset: "Por defecto (global)", mlIdentitySaved: "Identidad visual guardada",
    vi_style: "Estética / estilo", vi_photography: "Tipo de fotografía", vi_lighting: "Iluminación",
    vi_environment: "Entorno", vi_people: "Personas", vi_wardrobe: "Vestimenta", vi_colors: "Paleta de color", vi_extra: "Indicaciones extra",
    go_strategy: "Estrategia", go_studio: "Content Studio", go_pipeline: "Pipeline", go_intelligence: "Intelligence", go_blog: "Blog",
    pipePublishHint: "Este estado es interno del pipeline. Para publicarlo en el blog público usa \"Enviar al Blog\" y publícalo desde la pestaña Blog.",
    intAllSectors: "Todos los sectores", intQueryPh: "Consulta / ángulo a explorar (opcional)…",
    intScan: "Escanear", intScanning: "Escaneando…", intNeedSource: "Selecciona al menos una fuente",
    intScanDone: "Escaneo completado", intNoData: "No se obtuvieron señales. Prueba otra consulta.",
    intScanningHint: "Rastreando la web en tiempo real y analizando oportunidades. Esto puede tardar hasta un minuto…",
    intSectors: "Sectores ecuestres", intNewSectorPh: "Nuevo sector…", intAddSector: "Añadir",
    intSectorAdded: "Sector añadido", intEmpty: "Aún no hay señales. Lanza un escaneo para descubrir oportunidades.",
    intComp: "Competencia", intScores: "Ver puntuaciones", intSeo: "SEO", intCommercial: "Comercial", intTrend: "Tendencia",
    intSendPipeline: "Enviar al pipeline", intSentPipeline: "Oportunidad enviada al pipeline",
    navBrief: "Daily Brief",
    dbTitle: "Daily Brief", dbSubtitle: "Informe diario de inteligencia editorial de Equestrian Partners",
    dbGenerate: "Generar brief", dbGenerating: "Generando…", dbGenerated: "Brief generado",
    dbHistory: "Historial", dbNoHistory: "Aún no hay briefs anteriores.",
    dbEmpty: "Aún no hay ningún brief. Genera el informe diario para ver tendencias, oportunidades, hooks y alertas.",
    dbTrends: "Tendencias", dbOpportunities: "Oportunidades", dbHooks: "Hooks", dbAlerts: "Alertas",
    dbCopied: "Hook copiado",
    koBlog: "Blog",
    blogTotal: "Total", blogPublished: "Publicados", blogDrafts: "Borradores", blogLanguages: "Idiomas",
    blogSearchPh: "Buscar artículos…", blogAllStatus: "Todos los estados", blogAllLangs: "Todos los idiomas",
    blogPublishedS: "Publicado", blogDraftS: "Borrador", blogNew: "Nuevo artículo",
    blogEmpty: "Aún no hay artículos. Crea el primero.", blogUntitled: "(sin título)",
    blogPublish: "Publicar", blogUnpublish: "Despublicar", blogPublishedT: "Artículo publicado",
    blogUnpublished: "Artículo despublicado", blogDuplicated: "Artículo duplicado", blogDeleted: "Artículo eliminado",
    blogDeleteConfirm: "¿Eliminar este artículo de forma permanente?",
    blogBack: "Volver a la lista", blogGenerate: "Generar con IA", blogGenerated: "Borrador generado con IA",
    blogNeedTitle: "El título es obligatorio", blogNeedTopic: "Escribe un título/tema para generar", blogSaved: "Artículo guardado",
    blogTitle2: "Título", blogSlug: "Slug (URL)", blogLang: "Idioma", blogStatus: "Estado", blogExcerpt: "Extracto",
    blogHero: "Imagen de portada (hero)", blogHeroPh: "Describe la imagen de portada…", blogHeroGen: "Generar", blogHeroUpload: "Subir",
    blogHeroSet: "Portada asignada", blogContent: "Contenido (Markdown)",
    blogPublishingHero: "Publicando: generando la imagen de portada…", blogHeroError: "No se pudo generar la portada; súbela manualmente e inténtalo de nuevo", blogHeroTimeout: "La portada está tardando más de lo normal; recarga en unos segundos",
    blogMetaTitle: "Meta título", blogMetaDesc: "Meta descripción", blogMetaKw: "Meta keywords",
    blogFaqAdd: "Añadir pregunta", blogFaqQ: "Pregunta", blogFaqA: "Respuesta",
    blogCtaLabel: "Texto del botón", blogCtaUrl: "URL del botón", blogCtaText: "Frase del CTA",
    blogTranslation: "Traducción / multi-idioma", blogTranslationHint: "Vincula este artículo con su versión en el otro idioma para conmutar automáticamente en la web pública.",
    blogLinkPick: "Elegir artículo a vincular…", blogLink: "Vincular", blogUnlink: "Desvincular",
    blogLinked: "Traducción vinculada", blogUnlinked: "Traducción desvinculada",
    blogAiTranslate: "Traducción automática con IA", blogAiTranslateHint: "Genera versiones nativas de este artículo en otros idiomas. Se crean como borradores vinculados que puedes revisar antes de publicar.",
    blogTranslateTo: "Traducir a", blogTranslateAll: "Traducir a todos los idiomas",
    blogTranslateStarted: "{n} traducción(es) en curso — aparecerán como borradores en unos segundos",
    blogTranslateNone: "Ya existen versiones en todos los idiomas", blogTranslatingBadge: "Traduciendo…",
    blogBulkTranslate: "Traducir todo el blog", blogBulkGo: "Traducir y publicar",
    blogBulkConfirm: "Se traducirán automáticamente todos los artículos publicados a los idiomas que falten (EN, ES, FR, DE, IT, PT) y se publicarán al terminar. Podrás editar cualquier traducción después. ¿Continuar?",
    blogBulkStarted: "{n} traducciones en curso — se publicarán automáticamente al terminar",
    blogTrTitle: "Traducir artículo", blogTrHint: "El idioma original nunca se vuelve a traducir. Selecciona los idiomas de destino.",
    blogTrOriginalTag: "Original", blogTrDoneTag: "Traducido",
    blogTrSelectAll: "Seleccionar pendientes", blogTrAutoPublish: "Publicar al terminar",
    blogTrSubmit: "Traducir",
    csTopic: "Tema / ángulo", csTopicPh: "Ej.: cómo elegir el primer caballo de doma sin equivocarte…",
    csNeedTopic: "Escribe un tema o ángulo primero",
    csHooks: "Hooks", csScript: "Guion", csVisual: "Dirección visual", csImage: "Generar imagen",
    csAddPipeline: "Añadir al pipeline", csAdded: "Pieza añadida al pipeline",
    cs_problem: "Problema", cs_consequence: "Consecuencia", cs_solution: "Solución", cs_body: "Contenido", cs_cta: "Llamada a la acción",
    fmt_reel: "Reel", fmt_carrusel: "Carrusel", fmt_post: "Post", fmt_story: "Story", fmt_newsletter: "Newsletter",
    fmt_articulo: "Artículo SEO", fmt_landing: "Landing", fmt_video: "Guion de vídeo", fmt_email: "Email",
    st_idea: "Idea", st_draft: "Borrador", st_ready: "Listo", st_published: "Publicado",
    pipeGenerating: "Generando…", pipeGenerated: "Contenido generado", pipeRegenerate: "Regenerar",
    pipeGenFor: "Generar", pipeToBlogBtn: "Publicar en Blog", pipeToBlog: "Artículo enviado al Blog (borrador)",
    pipeInBlog: "En el Blog",
    blogScheduled: "Programados", blogArchived: "Archivados", blogScheduledS: "Programado", blogArchivedS: "Archivado",
    blogArchive: "Archivar",
    blogSchedule: "Programar publicación", blogScheduleBtn: "Programar", blogNeedDate: "Elige una fecha y hora",
    blogScheduledT: "Artículo programado",
    blogScheduleHint: "Guarda primero el artículo. Se publicará automáticamente en la fecha indicada.",
    blogInternalLinks: "Enlaces internos", blogAddLink: "Añadir enlace", blogLinkText: "Texto del enlace",
    pipeAllStatus: "Todos los estados", pipeAllSectors: "Todos los sectores",
    pipeEmpty: "Aún no hay piezas. Créalas desde el Content Studio.",
    pipeEdit: "Editar pieza", pipeDuplicated: "Pieza duplicada", pipeDeleted: "Pieza eliminada",
    pipeSaved: "Pieza guardada", pipeDeleteConfirm: "¿Eliminar esta pieza de forma permanente?",
  },
};

export default es;
